import $ from 'jquery';

import {assertAndContinue} from 'Asserts';
import BenchlingConfig from 'BenchlingConfig';
import * as popup from 'Popup';

function blastBases(seq, name) {
  assertAndContinue(
    BenchlingConfig.MOLBIO_ENABLE_EXTERNAL_BLAST,
    'Cannot blast without MOLBIO_ENABLE_EXTERNAL_BLAST flag on'
  );
  function doBlast() {
    const urlBase = 'http://blast.ncbi.nlm.nih.gov/Blast.cgi';
    const param = $.param({
      PAGE_TYPE: 'BlastSearch',
      USER_FORMAT_DEFAULTS: 'on',
      PAGE: 'MegaBlast',
      PROGRAM: 'blastn',
      QUERY: seq,
      JOB_TITLE: `Benchling Query: ${name}`,
      GAPCOSTS: '0%200',
      MATCH_SCORES: '1,-2',
      DATABASE: 'nr',
      BLAST_PROGRAMS: 'megaBlast',
      MAX_NUM_SEQ: '100',
      SHORT_QUERY_ADJUST: 'on',
      EXPECT: '10',
      WORD_SIZE: '28',
      REPEATS: 'repeat_9606',
      TEMPLATE_TYPE: '0',
      TEMPLATE_LENGTH: '0',
      FILTER: 'm',
      SHOW_OVERVIEW: 'on',
      SHOW_LINKOUT: 'on',
      ALIGNMENT_VIEW: 'Pairwise',
      MASK_CHAR: '2',
      MASK_COLOR: '1',
      GET_SEQUENCE: 'on',
      NUM_OVERVIEW: '100',
      DESCRIPTIONS: '100',
      ALIGNMENTS: '100',
      FORMAT_OBJECT: 'Alignment',
      FORMAT_TYPE: 'HTML',
      OLD_BLAST: 'false',
    });

    return window.open(`${urlBase}?${param}`, '_blank');
  }

  if (window.MOLBIO_ENABLE_EXTERNAL_BLAST_CONFIRMATION_MODAL) {
    const link = 'blast.ncbi.nlm.nih.gov';
    return new popup.Confirm({
      title: 'NCBI Blast',
      msg: `This will send the selected sequence to <a href='http://${link}'>${link}</a>. Do you want to continue?`,
    })
      .choice('Yes', 'btn-af-primary', doBlast)
      .choice('Cancel', 'btn-af-default')
      .show();
  } else {
    return doBlast();
  }
}

function blastSequence(sequence) {
  const selection = sequence.get('selection');
  const start = selection.start();
  const end = selection.end();
  const seq = sequence.get('dna').slice(start, end)[0].bases;
  const name = sequence.name();
  return blastBases(seq, name);
}

const blastPrimer = (primer) => blastBases(primer.bases(), primer.name());

export {blastBases, blastSequence, blastPrimer};
